package com.schoolconnect.app.feature.academicyears

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.list.AdminListFilterBanner
import com.schoolconnect.app.designsystem.list.AdminListMessageAndFilters
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardItem
import com.schoolconnect.app.designsystem.list.AdminListSummaryCards
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListToolbar
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.feature.common.footerText
import com.schoolconnect.app.feature.common.toWindow
import com.schoolconnect.app.datasource.network.response.AcademicYearAnalyticsMetrics
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.activity_calendar
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.clock
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.trash
import org.jetbrains.compose.resources.painterResource

@Composable
fun AcademicYearsScreen(
    state: AcademicYearsUiState,
    onEvent: (AcademicYearsUiEvent) -> Unit,
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    val pageItems = state.items
    val pageWindow = state.paging.toWindow(pageItems.size)

    var showRowsPerPageMenu by remember { mutableStateOf(false) }
    var filterModalOpen by remember { mutableStateOf(false) }

    val totalCountText = "Across all schools"
    val activeCount = state.items.count { it.isActive }
    val inactiveCount = state.items.count { !it.isActive }
    val upcomingCount = state.items.count { it.status == AcademicYearStatus.UPCOMING }
    val closedCount = state.items.count { it.status == AcademicYearStatus.CLOSED }
    var accountMenuExpanded by remember { mutableStateOf(false) }
    val roleLabel = shellRoleLabel(shellRoleCode)
    val roleSubtitle = shellRoleSubtitle(shellRoleCode)
    val initials = shellAvatarInitials(roleLabel)
    val analyticsMetrics = state.academicYearAnalytics?.metrics

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        AdminListPageScaffold(
        title = "Academic Years",
        subtitle = "Define academic term windows and lifecycle",
        breadcrumb = listOf("School Setup", "Academic Years"),
        headerActions = {
            ShellTopRightActions(
                roleLabel = roleLabel,
                roleSubtitle = roleSubtitle,
                initials = initials,
                expanded = accountMenuExpanded,
                onExpandedChange = { accountMenuExpanded = it },
                onChangeRole = onChangeRole,
                onLogout = onLogout
            )
        },
        backgroundColor = AcademicYearsBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        summaryCards = {
            if (state.isAnalyticsLoading && analyticsMetrics == null) {
                AcademicYearsSummaryCardsShimmer()
            } else {
                val summaryItems = analyticsMetrics?.let {
                    academicYearsAnalyticsSummaryItems(it)
                } ?: academicYearsFallbackSummaryItems(
                    total = state.items.size,
                    active = activeCount,
                    inactive = inactiveCount,
                    current = state.items.count { it.status == AcademicYearStatus.ACTIVE },
                    upcoming = upcomingCount,
                    closed = closedCount
                )
                AdminListSummaryCards(
                    items = summaryItems
                )
            }
        },
        banner = {
            val filters = academicYearFilterLabels(state.filters)
            if (filters.isEmpty()) {
                AdminListFilterBanner(
                    chips = emptyList(),
                    onClearAll = {}
                )
            } else {
                AdminListMessageAndFilters(
                    message = "",
                    onDismissMessage = {},
                    chips = filters,
                    onClearAll = {
                        onEvent(AcademicYearsUiEvent.FilterApplied(AcademicYearFilterCriteria()))
                    },
                    onRemoveChip = { chip ->
                        val next = when {
                            chip.startsWith("Search:") -> state.filters.copy(searchQuery = "")
                            chip.startsWith("School:") -> state.filters.copy(school = "")
                            chip.startsWith("Lifecycle:") -> state.filters.copy(status = AcademicYearsFilter.ALL)
                            chip.startsWith("Status:") -> state.filters.copy(activeStatus = AcademicYearActiveStatusFilter.ALL)
                            chip.startsWith("Start year:") -> state.filters.copy(startYear = "")
                            chip.startsWith("End year:") -> state.filters.copy(endYear = "")
                            chip.startsWith("Created:") -> state.filters.copy(createdFrom = "", createdTo = "")
                            else -> state.filters
                        }
                        onEvent(AcademicYearsUiEvent.FilterApplied(next))
                    },
                    onEditFilters = { filterModalOpen = true },
                    filterBackgroundColor = Color(0xFFF2F7FF),
                    filterBorderColor = AcademicYearsBorder,
                    filterContentColor = AcademicYearsNavy,
                    filterAccentColor = AcademicYearsPrimary
                )
            }
        },
        toolbar = {
            AdminListToolbar(
                searchQuery = state.filters.searchQuery,
                onSearchQueryChanged = { onEvent(AcademicYearsUiEvent.SearchChanged(it)) },
                searchPlaceholder = "Search by school or year...",
                searchWidth = 370.dp,
                surfaceColor = AcademicYearsCard,
                borderColor = AcademicYearsBorder,
                searchIconTint = AcademicYearsMuted,
                searchTextColor = AcademicYearsNavy,
                searchCursorColor = AcademicYearsPrimary,
                inlineContent = {
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.status.lifecycleLabel().let { if (it == "All") "All Lifecycles" else it },
                        options = listOf("Current", "Upcoming", "Completed"),
                        onSelected = { selected ->
                            onEvent(
                                AcademicYearsUiEvent.FilterApplied(
                                    state.filters.copy(status = selected.toAcademicYearsFilter())
                                )
                            )
                        },
                        modifier = Modifier.width(176.dp),
                        allOptionLabel = "All Lifecycles"
                    )
                    AppLabeledDropdownField(
                        label = "",
                        value = state.filters.activeStatus.displayLabel().let { if (it == "All") "All Statuses" else it },
                        options = listOf("Active", "Inactive"),
                        onSelected = { selected ->
                            onEvent(
                                AcademicYearsUiEvent.FilterApplied(
                                    state.filters.copy(activeStatus = selected.toAcademicYearActiveStatusFilter())
                                )
                            )
                        },
                        modifier = Modifier.width(160.dp),
                        allOptionLabel = "All Statuses"
                    )
                }
            ) {
                AdminListToolbarButton(
                    label = "Reset",
                    icon = painterResource(Res.drawable.refresh_cw),
                    onClick = {
                        onEvent(AcademicYearsUiEvent.FilterApplied(AcademicYearFilterCriteria()))
                    },
                    width = 112.dp,
                    borderColor = AcademicYearsPrimary,
                    contentColor = AcademicYearsPrimary
                )
                AdminListToolbarButton(
                    label = "More Filters",
                    icon = painterResource(Res.drawable.filter),
                    onClick = { filterModalOpen = true },
                    width = 148.dp,
                    borderColor = AcademicYearsPrimary,
                    contentColor = AcademicYearsPrimary
                )
            }
        },
        table = { tableModifier ->
            AdminListTableCard(
                modifier = tableModifier,
                surfaceColor = Color.White,
                borderColor = AcademicYearsBorder,
                header = {
                        AcademicYearsTableHeader(
                            sortField = state.sortField,
                            sortAscending = state.sortAscending,
                            onSortChanged = { onEvent(AcademicYearsUiEvent.SortChanged(it)) }
                        )
                },
                body = {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f)
                    ) {
                        if (state.isLoading) {
                            AdminListTableShimmer(
                                columns = academicYearsTableShimmerColumns(),
                                rowCount = 6,
                                modifier = Modifier.fillMaxWidth(),
                                rowHeight = 52.dp,
                                horizontalPadding = 24.dp,
                                verticalPadding = 0.dp,
                                surfaceColor = Color.White,
                                borderColor = AcademicYearsBorder
                            )
                        } else if (pageItems.isEmpty()) {
                            Box(
                                modifier = Modifier
                                    .fillMaxSize(),
                                contentAlignment = Alignment.Center
                            ) {
                                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                    Text(
                                        text = "No academic years found",
                                        color = AcademicYearsNavy,
                                        fontWeight = FontWeight.ExtraBold
                                    )
                                    Spacer(modifier = Modifier.height(6.dp))
                                    Text(
                                        text = "Try a different search or filter.",
                                        color = AcademicYearsMuted,
                                        fontWeight = FontWeight.Medium
                                    )
                                }
                            }
                        } else {
                            AdminListTableBody(
                                modifier = Modifier.fillMaxSize(),
                                items = pageItems,
                                key = { it.id }
                            ) { item ->
                                AcademicYearRow(
                                    item = item,
                                    expanded = state.openMenuId == item.id,
                                    onMenuClick = { onEvent(AcademicYearsUiEvent.MenuToggled(item.id)) },
                                    onMenuDismiss = { onEvent(AcademicYearsUiEvent.MenuClosed) },
                                    onViewDetails = { onEvent(AcademicYearsUiEvent.ViewDetailsClicked(item.id)) },
                                    onEdit = { onEvent(AcademicYearsUiEvent.EditClicked(item.id)) },
                                    onToggleStatus = { onEvent(AcademicYearsUiEvent.ToggleStatusClicked(item.id)) },
                                    onDelete = { onEvent(AcademicYearsUiEvent.DeleteClicked(item.id)) },
                                    showDivider = item.id != pageItems.lastOrNull()?.id
                                )
                            }
                        }
                    }
                },
                footer = {
                    AdminListFooter(
                        pageText = state.paging.footerText(pageItems.size, "academic years"),
                        pageIndex = state.paging.pageIndex.coerceAtMost(pageWindow.pageCount - 1),
                        pageCount = pageWindow.pageCount,
                        onPageChanged = { onEvent(AcademicYearsUiEvent.PageChanged(it)) },
                        pageSize = state.paging.pageSize,
                        rowsPerPageExpanded = showRowsPerPageMenu,
                        onRowsPerPageToggle = { showRowsPerPageMenu = !showRowsPerPageMenu },
                        onRowsPerPageDismiss = { showRowsPerPageMenu = false },
                        onPageSizeChanged = { onEvent(AcademicYearsUiEvent.RowsPerPageChanged(it)) },
                        footerColor = AcademicYearsMuted,
                        borderColor = AcademicYearsBorder,
                        surfaceColor = AcademicYearsCard,
                        primaryColor = AcademicYearsPrimary,
                        navyColor = AcademicYearsNavy,
                        mutedColor = AcademicYearsMuted
                    )
                }
            )
        },
        bottomAction = {
            AdminListPrimaryActionButton(
                label = "Add Academic Year",
                icon = painterResource(Res.drawable.plus),
                onClick = { onEvent(AcademicYearsUiEvent.AddClicked) },
                backgroundColor = AcademicYearsPrimary
            )
        }
    )

        if (filterModalOpen) {
            AcademicYearsFilterModal(
                open = true,
                initialFilters = state.filters,
                schoolOptions = state.schoolOptions.ifEmpty { academicYearFilterSchoolOptions(state.items) },
                startYearOptions = academicYearFilterYearOptions(state.items) { it.startDate },
                endYearOptions = academicYearFilterYearOptions(state.items) { it.endDate },
                onClose = { filterModalOpen = false },
                onApply = {
                    onEvent(AcademicYearsUiEvent.FilterApplied(it))
                    filterModalOpen = false
                }
            )
        }

        when (state.dialogMode) {
            AcademicYearsDialogMode.NONE -> Unit
            AcademicYearsDialogMode.DETAILS -> {
                val item = state.items.firstOrNull { it.id == state.dialogItemId }
                if (item != null) {
                    AcademicYearViewModal(
                        item = item,
                        onClose = { onEvent(AcademicYearsUiEvent.DialogDismissed) }
                    )
                }
            }
            AcademicYearsDialogMode.EDITOR -> {
                val item = state.items.firstOrNull { it.id == state.dialogItemId }
                if (item == null) {
                    AcademicYearEditorModal(
                        draft = state.editorDraft,
                        schoolOptions = state.schoolOptions.ifEmpty { AcademicYearDefaultSchoolOptions },
                        onDismiss = { if (!state.isEditorSaving) onEvent(AcademicYearsUiEvent.DialogDismissed) },
                        onSave = { onEvent(AcademicYearsUiEvent.DialogSaveRequested) },
                        isSaving = state.isEditorSaving,
                        apiError = state.errorMessage,
                        onAcademicYearChanged = { onEvent(AcademicYearsUiEvent.EditorAcademicYearChanged(it)) },
                        onSchoolChanged = { onEvent(AcademicYearsUiEvent.EditorSchoolChanged(it)) },
                        onStartDateChanged = { onEvent(AcademicYearsUiEvent.EditorStartDateChanged(it)) },
                        onEndDateChanged = { onEvent(AcademicYearsUiEvent.EditorEndDateChanged(it)) },
                        onStatusChanged = { onEvent(AcademicYearsUiEvent.EditorStatusChanged(it)) }
                    )
                } else {
                    AcademicYearEditModal(
                        draft = state.editorDraft,
                        schoolOptions = state.schoolOptions.ifEmpty { AcademicYearDefaultSchoolOptions },
                        onDismiss = { if (!state.isEditorSaving) onEvent(AcademicYearsUiEvent.DialogDismissed) },
                        onSave = { onEvent(AcademicYearsUiEvent.DialogSaveRequested) },
                        isSaving = state.isEditorSaving,
                        apiError = state.errorMessage,
                        onAcademicYearChanged = { onEvent(AcademicYearsUiEvent.EditorAcademicYearChanged(it)) },
                        onSchoolChanged = { onEvent(AcademicYearsUiEvent.EditorSchoolChanged(it)) },
                        onStartDateChanged = { onEvent(AcademicYearsUiEvent.EditorStartDateChanged(it)) },
                        onEndDateChanged = { onEvent(AcademicYearsUiEvent.EditorEndDateChanged(it)) },
                        onStatusChanged = { onEvent(AcademicYearsUiEvent.EditorStatusChanged(it)) }
                    )
                }
            }
            AcademicYearsDialogMode.TOGGLE_CONFIRM -> {
                val item = state.items.firstOrNull { it.id == state.dialogItemId }
                if (item != null) {
                    val isActivating = !item.isActive
                    val actionLabel = if (isActivating) "Activate" else "Inactivate"
                    AppConfirmationDialog(
                        onDismiss = { onEvent(AcademicYearsUiEvent.DialogDismissed) },
                        title = "$actionLabel Academic Year",
                        subtitle = if (isActivating) {
                            "This will mark the academic year as active and current."
                        } else {
                            "This will mark the academic year as inactive."
                        },
                        bodyText = "$actionLabel ${item.academicYear} for ${item.school}?",
                        confirmLabel = actionLabel,
                        onConfirm = { onEvent(AcademicYearsUiEvent.ToggleStatusConfirmed) },
                        tone = AppConfirmationDialogTone.Primary
                    )
                }
            }
            AcademicYearsDialogMode.DELETE_CONFIRM -> {
                val item = state.items.firstOrNull { it.id == state.dialogItemId }
                if (item != null) {
                    AppConfirmationDialog(
                        onDismiss = { onEvent(AcademicYearsUiEvent.DialogDismissed) },
                        title = "Delete Academic Year",
                        subtitle = "This action cannot be undone.",
                        bodyText = "Delete ${item.academicYear} for ${item.school}?",
                        confirmLabel = "Delete",
                        onConfirm = { onEvent(AcademicYearsUiEvent.DeleteConfirmed) },
                        tone = AppConfirmationDialogTone.Danger
                    )
                }
            }
        }
    }
}

@Composable
private fun AcademicYearsTableHeader(
    sortField: AcademicYearsSortField,
    sortAscending: Boolean,
    onSortChanged: (AcademicYearsSortField) -> Unit
) {
    AdminListSortHeaderRow(
        columns = listOf(
            AdminListSortColumn(
                label = "School",
                weight = 1.5f,
                selected = sortField == AcademicYearsSortField.SCHOOL,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.SCHOOL) }
            ),
            AdminListSortColumn(
                label = "Academic Year",
                weight = 1.0f,
                selected = sortField == AcademicYearsSortField.ACADEMIC_YEAR,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.ACADEMIC_YEAR) }
            ),
            AdminListSortColumn(
                label = "Lifecycle",
                weight = 0.95f,
                selected = sortField == AcademicYearsSortField.LIFECYCLE,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.LIFECYCLE) }
            ),
            AdminListSortColumn(
                label = "Start Date",
                weight = 1.0f,
                selected = sortField == AcademicYearsSortField.START_DATE,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.START_DATE) }
            ),
            AdminListSortColumn(
                label = "End Date",
                weight = 1.0f,
                selected = sortField == AcademicYearsSortField.END_DATE,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.END_DATE) }
            ),
            AdminListSortColumn(
                label = "Status",
                weight = 0.75f,
                selected = sortField == AcademicYearsSortField.STATUS,
                ascending = sortAscending,
                onClick = { onSortChanged(AcademicYearsSortField.STATUS) }
            )
        ),
        actionsWeight = 0.95f,
        height = 44.dp,
        horizontalPadding = 24.dp,
        labelColor = AcademicYearsNavy,
        selectedColor = AcademicYearsPrimary,
        unselectedColor = AcademicYearsMuted
    )
}

@Composable
private fun AcademicYearRow(
    item: AcademicYearListItem,
    expanded: Boolean,
    onMenuClick: () -> Unit,
    onMenuDismiss: () -> Unit,
    onViewDetails: () -> Unit,
    onEdit: () -> Unit,
    onToggleStatus: () -> Unit,
    onDelete: () -> Unit,
    showDivider: Boolean
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .onViewDoubleClick(onViewDetails)
                .height(52.dp)
                .padding(horizontal = 24.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            TableBodyCell(item.school, 1.5f)
            TableBodyCell(item.academicYear, 1.0f)
            Box(modifier = Modifier.weight(0.95f)) {
                AcademicYearStatusChip(item.status)
            }
            TableBodyCell(item.startDate, 1.0f)
            TableBodyCell(item.endDate, 1.0f)
            Box(modifier = Modifier.weight(0.75f)) {
                AcademicYearActiveStatusChip(item.isActive)
            }
            Box(
                modifier = Modifier.weight(0.95f),
                contentAlignment = Alignment.CenterStart
            ) {
                AdminListRowActionBar(
                    isActive = item.isActive,
                    expanded = expanded,
                    onExpandedChange = { if (it) onMenuClick() else onMenuDismiss() },
                    onDismissRequest = onMenuDismiss,
                    onView = onViewDetails,
                    onEdit = onEdit,
                    onToggleStatus = onToggleStatus,
                    onDelete = onDelete,
                    width = 190.dp,
                    surfaceColor = AcademicYearsCard,
                    borderColor = AcademicYearsBorder
                )
            }
        }
        if (showDivider) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.dp)
                    .background(AcademicYearsLine)
            )
        }
    }
}

@Composable
private fun RowScope.TableBodyCell(
    text: String,
    weight: Float
) {
    Box(
        modifier = Modifier.weight(weight),
        contentAlignment = Alignment.CenterStart
    ) {
        AdminListTableBodyText(
            text = text,
            color = AcademicYearsNavy
        )
    }
}

@Composable
private fun AcademicYearsAddButton(
    onClick: () -> Unit
) {
    AppOutlinedButton(
        onClick = onClick,
        modifier = Modifier
            .height(40.dp),
        shape = RoundedCornerShape(8.dp),
        colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(
            containerColor = AcademicYearsPrimary,
            contentColor = Color.White
        ),
        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 18.dp)
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(
                painter = painterResource(Res.drawable.plus),
                contentDescription = null,
                tint = Color.White,
                modifier = Modifier.size(18.dp)
            )
            Text(
                text = "Add Academic Year",
                fontSize = 14.sp,
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}

private fun academicYearsTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn(label = "School", weight = 1.5f),
    AdminListHeaderColumn(label = "Academic Year", weight = 1.0f),
    AdminListHeaderColumn(label = "Lifecycle", weight = 0.95f),
    AdminListHeaderColumn(label = "Start Date", weight = 1.0f),
    AdminListHeaderColumn(label = "End Date", weight = 1.0f),
    AdminListHeaderColumn(label = "Status", weight = 0.75f),
    AdminListHeaderColumn(label = "Actions", weight = 0.95f)
)

@Composable
private fun percentage(part: Int, total: Int): Int {
    if (total <= 0) return 0
    return ((part.toFloat() / total.toFloat()) * 100f).toInt()
}

@Composable
private fun AcademicYearsSummaryCardsShimmer() {
    val transition = rememberInfiniteTransition(label = "academic_years_summary_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -400f,
        targetValue = 1400f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200),
            repeatMode = RepeatMode.Restart
        ),
        label = "academic_years_summary_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        repeat(5) {
            Card(
                modifier = Modifier
                    .weight(1f)
                    .height(104.dp),
                shape = RoundedCornerShape(8.dp),
                colors = CardDefaults.cardColors(containerColor = AcademicYearsCard),
                border = androidx.compose.foundation.BorderStroke(1.dp, AcademicYearsBorder)
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = 12.dp, vertical = 12.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Box(
                        modifier = Modifier
                            .size(48.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        Box(
                            modifier = Modifier
                                .width(72.dp)
                                .height(14.dp)
                                .clip(RoundedCornerShape(6.dp))
                                .background(shimmerBrush)
                        )
                        Box(
                            modifier = Modifier
                                .width(40.dp)
                                .height(24.dp)
                                .clip(RoundedCornerShape(6.dp))
                                .background(shimmerBrush)
                        )
                        Box(
                            modifier = Modifier
                                .width(96.dp)
                                .height(14.dp)
                                .clip(RoundedCornerShape(6.dp))
                                .background(shimmerBrush)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun academicYearsAnalyticsSummaryItems(
    metrics: AcademicYearAnalyticsMetrics
): List<AdminListSummaryCardItem> {
    val total = metrics.totalAcademicYears
    return listOf(
        AdminListSummaryCardItem(
            title = "Active",
            value = metrics.activeYears.toString(),
            subtitle = "${percentage(metrics.activeYears, total)}% of total",
            icon = painterResource(Res.drawable.circle_check),
            accent = AcademicYearsStatusActive,
            accentBg = Color(0xFFEAF8F0),
            subtitleColor = AcademicYearsStatusActive,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Current",
            value = metrics.currentYears.toString(),
            subtitle = "${percentage(metrics.currentYears, total)}% of total",
            icon = painterResource(Res.drawable.calendar),
            accent = AcademicYearsStatusCurrent,
            accentBg = AcademicYearsStatusCurrentBg,
            subtitleColor = AcademicYearsStatusCurrent,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Upcoming",
            value = metrics.upcomingYears.toString(),
            subtitle = "${percentage(metrics.upcomingYears, total)}% of total",
            icon = painterResource(Res.drawable.clock),
            accent = AcademicYearsStatusUpcoming,
            accentBg = AcademicYearsStatusUpcomingBg,
            subtitleColor = AcademicYearsStatusUpcoming,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Completed",
            value = metrics.closedYears.toString(),
            subtitle = "${percentage(metrics.closedYears, total)}% of total",
            icon = painterResource(Res.drawable.activity_calendar),
            accent = AcademicYearsStatusCompleted,
            accentBg = AcademicYearsStatusCompletedBg,
            subtitleColor = AcademicYearsStatusCompleted,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Inactive",
            value = metrics.inactiveYears.toString(),
            subtitle = "${percentage(metrics.inactiveYears, total)}% of total",
            icon = painterResource(Res.drawable.ban),
            accent = AcademicYearsStatusInactive,
            accentBg = Color(0xFFFFEDEE),
            subtitleColor = AcademicYearsStatusInactive,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        )
    )
}

@Composable
private fun academicYearsFallbackSummaryItems(
    total: Int,
    active: Int,
    inactive: Int,
    current: Int,
    upcoming: Int,
    closed: Int
): List<AdminListSummaryCardItem> {
    return listOf(
        AdminListSummaryCardItem(
            title = "Active",
            value = active.toString(),
            subtitle = "${percentage(active, total)}% of total",
            icon = painterResource(Res.drawable.circle_check),
            accent = AcademicYearsStatusActive,
            accentBg = Color(0xFFEAF8F0),
            subtitleColor = AcademicYearsStatusActive,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Current",
            value = current.toString(),
            subtitle = "${percentage(current, total)}% of total",
            icon = painterResource(Res.drawable.calendar),
            accent = AcademicYearsStatusCurrent,
            accentBg = AcademicYearsStatusCurrentBg,
            subtitleColor = AcademicYearsStatusCurrent,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Upcoming",
            value = upcoming.toString(),
            subtitle = "${percentage(upcoming, total)}% of total",
            icon = painterResource(Res.drawable.clock),
            accent = AcademicYearsStatusUpcoming,
            accentBg = AcademicYearsStatusUpcomingBg,
            subtitleColor = AcademicYearsStatusUpcoming,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Completed",
            value = closed.toString(),
            subtitle = "${percentage(closed, total)}% of total",
            icon = painterResource(Res.drawable.activity_calendar),
            accent = AcademicYearsStatusCompleted,
            accentBg = AcademicYearsStatusCompletedBg,
            subtitleColor = AcademicYearsStatusCompleted,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        ),
        AdminListSummaryCardItem(
            title = "Inactive",
            value = inactive.toString(),
            subtitle = "${percentage(inactive, total)}% of total",
            icon = painterResource(Res.drawable.ban),
            accent = AcademicYearsStatusInactive,
            accentBg = Color(0xFFFFEDEE),
            subtitleColor = AcademicYearsStatusInactive,
            surfaceColor = AcademicYearsCard,
            borderColor = AcademicYearsBorder,
            textColor = AcademicYearsNavy,
        )
    )
}

private val AcademicYearsStatusActive = Color(0xFF16A34A)
private val AcademicYearsStatusCurrent = AcademicYearStatus.ACTIVE.accent
private val AcademicYearsStatusUpcoming = AcademicYearStatus.UPCOMING.accent
private val AcademicYearsStatusCompleted = AcademicYearStatus.CLOSED.accent
private val AcademicYearsStatusInactive = Color(0xFFDC2626)
private val AcademicYearsStatusCurrentBg = AcademicYearStatus.ACTIVE.accentSoft
private val AcademicYearsStatusUpcomingBg = AcademicYearStatus.UPCOMING.accentSoft
private val AcademicYearsStatusCompletedBg = AcademicYearStatus.CLOSED.accentSoft
